/* eslint-disable max-len */
/* eslint-disable prefer-destructuring */

import { getMenuContent } from '../helpers/helpers';
import { FOOTER_MENU_KEY } from '../static/constants';

export default state => getMenuContent(state, FOOTER_MENU_KEY);
